export type ScreenSection = 'Header' | 'Footer' | 'Sidebar' | 'Content';

export const ScreenSectionSymbols: Record<ScreenSection, symbol> = {
	Header: Symbol('screen-section:Header'),
	Footer: Symbol('screen-section:Footer'),
	Sidebar: Symbol('screen-section:Sidebar'),
	Content: Symbol('screen-section:Content')
};
